import { SidenavConfig } from 'app/modules/navigator/models';

// Utils
import routes, { ROUTES_MAP } from 'app/shared/utils/routes';
import permissions from 'app/shared/utils/permissions';
import {
  IconAlertTriangle,
  IconClipboard,
  IconListSearch,
  IconSettingsAutomation,
  IconUsers,
  IconDatabaseEdit,
  IconBriefcase,
  IconFlag,
  IconBuildingBank,
  IconChartLine,
  IconList,
  IconScale,
  IconWorld,
  IconSparkles,
  IconForms,
} from '@u21/tabler-icons';
import { FeatureFlag } from 'app/shared/featureFlags/models';

export const SIDENAV_CONFIG: SidenavConfig[] = [
  {
    hasPermissions: [permissions.readAlerts],
    tablerIcon: IconFlag,
    label: 'Alerts',
    link: routes.lumos.alerts,
    marker: 'first',
  },
  {
    hasPermissions: [permissions.readCases],
    tablerIcon: IconBriefcase,
    label: 'Cases',
    link: routes.lumos.cases,
  },
  {
    anyPermissions: ROUTES_MAP.lists.anyPermissions,
    tablerIcon: IconList,
    label: 'Lists',
    link: ROUTES_MAP.lists.path,
  },
  {
    hasPermissions: [permissions.readRules],
    tablerIcon: IconScale,
    label: 'Rules',
    nonExactMatch: true,
    link: ROUTES_MAP.rules.path,
  },
  {
    anyPermissions: [permissions.readSars, permissions.readFintrac],
    tablerIcon: IconBuildingBank,
    label: 'Report Filings',
    link: routes.lumos.filings,
  },
  {
    hasPermissions: [permissions.readAiAgents],
    tablerIcon: IconSparkles,
    label: 'AI',
    link: ROUTES_MAP.ai.path,
    marker: 'first',
  },
  {
    anyPermissions: ROUTES_MAP.dashboards.anyPermissions,
    tablerIcon: IconChartLine,
    label: 'Reporting & Dashboards',
    link: ROUTES_MAP.dashboards.path,
  },
  {
    anyPermissions: ROUTES_MAP.dataExplorer.anyPermissions,
    tablerIcon: IconListSearch,
    label: 'Data Explorer',
    link: routes.lumos.dataExplorer,
  },
  {
    tablerIcon: IconDatabaseEdit,
    label: 'Data Management',
    link: ROUTES_MAP.dataManagement.path,
  },
  {
    hasPermissions: [permissions.readRiskRatings],
    tablerIcon: IconAlertTriangle,
    label: 'Risk Ratings',
    link: ROUTES_MAP.riskRatings.path,
  },
  {
    anyPermissions: ROUTES_MAP.userManagement.anyPermissions,
    label: 'User Management',
    link: ROUTES_MAP.userManagement.path,
    tablerIcon: IconUsers,
  },
  {
    anyPermissions: ROUTES_MAP.externalForms.anyPermissions,
    tablerIcon: IconForms,
    label: 'External Forms',
    link: ROUTES_MAP.rfi.path,
  },
  {
    anyPermissions: ROUTES_MAP.workflows.anyPermissions,
    label: 'Workflows',
    link: ROUTES_MAP.workflows.path,
    tablerIcon: IconSettingsAutomation,
  },
  {
    hasPermissions: ROUTES_MAP.orgManagement.permissions,
    tablerIcon: IconWorld,
    label: 'Org Management',
    link: ROUTES_MAP.orgManagement.path,
    marker: 'first',
  },
  {
    featureFlag: FeatureFlag.AI_ADMIN_DASHBOARD,
    hasPermissions: ROUTES_MAP.aiAdmin.permissions,
    label: 'AI Admin Dashboard',
    link: ROUTES_MAP.aiAdmin.path,
    tablerIcon: IconSparkles,
  },
  {
    hasPermissions: ROUTES_MAP.rulesAdmin.permissions,
    label: 'Rules Admin Dashboard',
    link: ROUTES_MAP.rulesAdmin.path,
    tablerIcon: IconClipboard,
  },
];
